/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-09 16:34:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-10 11:22:27
 */
import React from 'react';

import { IconFont } from '..';
import Pinned from './Pinned';
import { ItemTop } from '.';
import './SFCTitleContent.less';
interface Props {
  /** 标题 */
  title: string;
  /** 内容 */
  content: string;
  /** 是否是最热 */
  hot?: boolean;
  /** 热门索引 */
  hotIndex?: number;
  /** 是否需要置顶功能 */
  pinned?: boolean;
  /** 是否是管理员 */
  isAdmin?: boolean;
  /** 问题id */
  id?: number;
  /** 置顶标志 */
  stickyFlag?: number;
  /** 置顶函数 */
  stickyAsk?: (stickType: number, articleOrQuestionId: number) => void;
  /** 当前是否为第一页 */
  pageNum?: number;
}

const SFCTitleContent: React.SFC<Props> = (props: Props) => {
  const {
    title,
    content,
    hot = false,
    hotIndex,
    pinned = false,
    isAdmin = false,
    id = 0,
    stickyFlag = 0,
    stickyAsk,
    pageNum = 1
  } = props;
  const askSticky = (stickType: number, articleOrQuestionId: number) => {
    stickyAsk && stickyAsk(stickType, articleOrQuestionId);
  };

  return (
    <div className="k-tech-com-title-content">
      <h2 className="k-tech-break-word title">
        <div className="title-flex">
          {title}
          {pinned && stickyFlag === 1 && <Pinned />}
        </div>
        {hot && hotIndex && hotIndex < 7 && pageNum === 1 && (
          <IconFont type={`icon-list-${hotIndex}`} className="hot-index" />
        )}

        {pinned && isAdmin && <ItemTop id={id} stickyFlag={stickyFlag} stickyFunc={askSticky} />}
      </h2>

      <div className="content">{content}</div>
    </div>
  );
};

export default React.memo(SFCTitleContent);
